import "core-js/modules/es.string.starts-with.js";
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import HeaderBrand from '@/components/header/HeaderBrand.vue';
import HeaderUser from '@/components/header/HeaderUser.vue';
import HeaderNotifications from '@/components/header/HeaderNotifications.vue';
import ClientProtocolsViewDialog, { openClientProtocolsViewDialog } from '@/components/header/dialogs/ClientProtocolsViewDialog.vue';
import { store, higherManagementUserIds, performanceUserIds } from '@/stores/store';
import { smAccess } from '@/views/management/stars-magnet/_store';
var headerVisible = ref(false);
export default {
  setup: function setup() {
    var route = useRoute();
    return {
      route: route,
      store: store,
      higherManagementUserIds: higherManagementUserIds,
      performanceUserIds: performanceUserIds,
      smAccess: smAccess,
      headerVisible: headerVisible
    };
  },
  components: {
    HeaderNotifications: HeaderNotifications,
    HeaderUser: HeaderUser,
    HeaderBrand: HeaderBrand,
    ClientProtocolsViewDialog: ClientProtocolsViewDialog
  },
  methods: {
    openClientProtocols: function openClientProtocols() {
      openClientProtocolsViewDialog();
    },
    clientViewToggle: function clientViewToggle() {
      // console.log(this.store.clientView);
      if (this.store.clientView) {
        this.store.setClientView(false);
      } else {
        this.store.setClientView(true);
      }
    },
    headerVisibleToggle: function headerVisibleToggle(name) {
      if (store.authUser) {
        if (name == 'login' || name == 'login-check' || name == 'logout' || name == 'not-found' || name == 'post' || name == 'client-review' || typeof name == 'string' && (name.startsWith('swell') || name.startsWith('pulse'))) {
          headerVisible.value = false;
        } else {
          headerVisible.value = true;
        }
      }
    },
    reloadPage: function reloadPage() {
      window.location.reload();
    }
  },
  watch: {
    "route.name": function routeName(name) {
      this.headerVisibleToggle(name);
    },
    // Stars Magnet menu item: shown to dashboard members only
    "store.currentUser.id": {
      immediate: true,
      handler: function handler(id) {
        var _store$currentUser;
        smAccess.reset();
        if (id && ((_store$currentUser = store.currentUser) === null || _store$currentUser === void 0 ? void 0 : _store$currentUser.user_type) === 'staff') smAccess.load();
      }
    }
  }
};